/* eslint-disable import/no-cycle */
import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/electonics-icon.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const ElectonicsIcon = withSvgProps(Svg)
